/**
 * Default select component with label positioned above the select field.
 * For selects with side labels, use CustomSelect instead.
 */

import React from 'react';
import { MenuItem } from '@mui/material';

import { FormGroup, Label, StyledSelect } from './styles';
import { DefaultCustomSelectProps } from './types';

const DefaultCustomSelect: React.FC<DefaultCustomSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder,
  required = false,
}) => {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}
      <StyledSelect
        value={value}
        onChange={onChange}
        displayEmpty
        required={required}
      >
        {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </StyledSelect>
    </FormGroup>
  );
};

export default DefaultCustomSelect;
